import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router';
import DiscountForm from './create/discountForm';
import DiscountsList from './list/discountsList';
import { ManagerContextProvider } from '../manager/components/context';
import PageError from '../error/pageError';

export default function Discounts({ organization, event, path }) {
    return (
        <ManagerContextProvider>
            <Switch>
                <Route exact path={`${path}`} render={routeProps => <DiscountsList organization={organization} event={event} />} />
                <Route
                    exact
                    path={`${path}/create`}
                    render={basenameProps => {
                        return <DiscountForm organization={organization} event={event} />;
                    }}
                />
                <Route
                    exact
                    path={`${path}/:id/edit`}
                    render={basenameProps => {
                        const discountId = basenameProps.match.params.id;
                        return <DiscountForm organization={organization} event={event} discountId={discountId} />;
                    }}
                />
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/E${event.id}/dashboard`} />} />
            </Switch>
        </ManagerContextProvider>
    );
}

Discounts.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
